function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.45 13.057h3.21a3.234 3.234 0 01-.767-.944H2.502c-.604 0-.926-.31-.926-.896V2.352c0-.58.317-.914.926-.914h6.123c.586 0 .92.328.92.914V7.46c.363.193.68.451.943.762V2.334c0-1.225-.603-1.84-1.816-1.84H2.449c-1.207 0-1.816.621-1.816 1.84v8.889c0 1.224.61 1.834 1.816 1.834zm.896-9.229h4.441a.363.363 0 00.363-.369c0-.2-.158-.352-.363-.352H3.346c-.217 0-.37.153-.37.352 0 .205.153.37.37.37zm0 2.045h4.441a.363.363 0 00.363-.37c0-.198-.158-.35-.363-.35H3.346c-.217 0-.37.152-.37.35 0 .206.153.37.37.37zm4.511 7.184a2.57 2.57 0 001.436-.428l1.318 1.324c.141.135.27.188.428.188.27 0 .475-.211.475-.51a.52.52 0 00-.164-.358l-1.336-1.335c.299-.428.474-.95.474-1.512a2.632 2.632 0 00-2.63-2.637 2.65 2.65 0 00-2.643 2.637 2.64 2.64 0 002.642 2.63zm0-.838a1.8 1.8 0 01-1.804-1.793c0-.979.808-1.793 1.804-1.793.979 0 1.788.814 1.788 1.793 0 .99-.803 1.793-1.788 1.793z"
});

function SvgQty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 15",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgQty;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/qty.svg
// module id = 1300
// module chunks = 10